import React, { useState, useEffect } from 'react';
import './App.css';
import api from './api';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import { Toaster } from './components/ui/sonner';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentView, setCurrentView] = useState('login'); // 'login', 'signup', 'dashboard'
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = api.getToken();
    if (token) {
      try {
        const userData = await api.getMe();
        setUser(userData);
        setIsAuthenticated(true);
        setCurrentView('dashboard');
      } catch (error) {
        console.error('Auth check failed:', error);
        setIsAuthenticated(false);
      }
    }
    setLoading(false);
  };

  const handleLogin = async (email, password) => {
    const data = await api.login(email, password);
    api.setToken(data.token);
    setUser(data.user);
    setIsAuthenticated(true);
    setCurrentView('dashboard');
  };

  const handleSignup = async (email, password) => {
    const data = await api.signup(email, password);
    api.setToken(data.token);
    setUser(data.user);
    setIsAuthenticated(true);
    setCurrentView('dashboard');
  };

  const handleLogout = () => {
    api.setToken(null);
    setIsAuthenticated(false);
    setUser(null);
    setCurrentView('login');
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }

  return (
    <div className="App">
      <Toaster position="top-right" />
      {!isAuthenticated && currentView === 'login' && (
        <Login onLogin={handleLogin} onSwitchToSignup={() => setCurrentView('signup')} />
      )}
      {!isAuthenticated && currentView === 'signup' && (
        <Signup onSignup={handleSignup} onSwitchToLogin={() => setCurrentView('login')} />
      )}
      {isAuthenticated && currentView === 'dashboard' && (
        <Dashboard user={user} onLogout={handleLogout} />
      )}
    </div>
  );
}

export default App;